import { render, staticRenderFns } from "./StepMenus.vue?vue&type=template&id=0bd9d60a&"
import script from "./StepMenus.vue?vue&type=script&lang=js&"
export * from "./StepMenus.vue?vue&type=script&lang=js&"
import style0 from "./StepMenus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports